import FillModel from './fill';
var MaskModels = {
  fill: FillModel
};
export default MaskModels;
//# sourceMappingURL=index.js.map